import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import styled from 'styled-components'
import SnackbarContents from './SnackbarContents'
import SnackbarText from './SnackbarText'
import CloseSnackbarButton from './CloseSnackbarButton'
import ErrorIcon from '@material-ui/icons/Error';

const ErrorSnackbar = styled<any>(Snackbar)<any>`
    div {
        background-color:${props => props.theme.colors.error};
        text-align: left;
    }
`

export default ({ onClickClose, ...props }) => (
    <ErrorSnackbar
        {...props}
        message={
            <SnackbarContents>
                <ErrorIcon/>
                <SnackbarText>
                    {props.message}
                </SnackbarText>
            </SnackbarContents>
        }
        action={[
            <CloseSnackbarButton key="close-button" onClick={onClickClose}/>
        ]}
    />
)
